import { createAsyncThunk } from '@reduxjs/toolkit';
import { AdminRepository } from 'repositories/AdminRepository';
import { IAdminPoolConfigsState } from 'store/slices/adminPoolConfigsSlice';
import { IAuthState } from 'store/slices/authSlice';
import { IPoolConfig, TAdminPoolConfigsQuery } from 'types';
import { EApiResponseStatus, IApiResponseDetails } from 'types/api';

export const fetchPoolConfigs = createAsyncThunk<
  { content: IPoolConfig[]; details: IApiResponseDetails },
  void,
  { state: { auth: IAuthState; adminPoolConfigs: IAdminPoolConfigsState } }
>('adminPoolConfigs/fetchPoolConfigs', async (_, { getState }) => {
  const {
    auth: { token },
    adminPoolConfigs: { currentPage, itemsPerPage },
  } = getState();
  if (!token) throw Error('no token');

  const params: TAdminPoolConfigsQuery = {
    page: String(currentPage),
    size: String(itemsPerPage),
    sort: 'pools.id,asc',
  };

  const adminPoolConfigsResponse = await AdminRepository.getPoolConfigs(token, params);

  if (adminPoolConfigsResponse.status === EApiResponseStatus.FAILURE) {
    throw Error(adminPoolConfigsResponse.error);
  }

  return adminPoolConfigsResponse.data;
});
